import SocketPlugin from './services.plugin';
import ApiPlugin from './api.plugin';
import AuthPlugin from './auth.plugin';
import Preloader from './preloader.plugin';

export default {
    install(Vue){
        Vue.use(ApiPlugin);
        Vue.use(SocketPlugin);
        Vue.use(AuthPlugin);
        Vue.use(Preloader);
    }
}


// WEBPACK FOOTER //
// ./src/plugins/index.js